import { FC, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { getQuestLlmInfo } from 'src/api/quests';
import { RoutesEnum } from 'src/types/navigation';
import LlmInfoView from './components/LlmInfoView';

type Params = { id: string };

const QuestLlmInfoPage: FC = () => {
    const { id } = useParams<Params>();
    const fetchSessions = useCallback(
        () => (id ? getQuestLlmInfo(id) : Promise.resolve({ data: [] })),
        [id]
    );

    return (
        <LlmInfoView
            title={`LLM info for quest ${id ?? ''}`}
            backTo={RoutesEnum.QUEST_DETAIL.replace(':id', id ?? '')}
            fetchSessions={fetchSessions}
        />
    );
};

export default QuestLlmInfoPage;
